import type { MeDto } from "../../types/index.ts";
import { ApiError } from "../../integrations/http.ts";
import type { LimitLock } from "./types.ts";

/** The server's refusal of a send at the monthly limit, however the page came to be out of date. */
export const isLimitRefusal = (error: unknown): boolean => error instanceof ApiError && error.code === "monthly_limit";

/**
 * Locked when the server says the limit is reached and its reset has not passed, or when a send
 * was refused with the limit's code since the server was last asked. The second case is a page
 * whose `/me` is older than the spend. The reset time is unknown then unless `/me` still lies ahead.
 */
export function limitLock(me: MeDto | null, refused: boolean, now: number): LimitLock {
  const resetsAt = me ? Date.parse(me.limitResetsAt) : Number.NaN;
  const ahead = Number.isFinite(resetsAt) && resetsAt > now;
  if (me?.limitReached && ahead) return { locked: true, resetsAt };
  if (refused) return { locked: true, resetsAt: ahead ? resetsAt : null };
  return { locked: false };
}

const day = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", day: "numeric", month: "long" });
const clock = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });

/** Stockholm time, whatever zone the browser is in: the limit counts Stockholm months. */
export function formatReset(resetsAt: number): string {
  return `${day.format(resetsAt)} kl. ${clock.format(resetsAt)}`;
}
